import React from "react"
import { css } from "@emotion/core"
// import GitalkComponent from "gitalk/dist/gitalk-component"
import "../../static/gitalk.css"
import Gitalk from "gatsby-plugin-gitalk"

const PostTemplate = () => {
  let gitalkConfig = {
    id: post.slug || post.id,
    title: post.title,
  }
  return <Gitalk options={gitalkConfig} />
}
export default function PrettyGitalk({ post }) {
  let gitalkConfig = {
    id: post.fields.slug || post.id,
    title: post.frontmatter.title,
  }
  return (
    <div
      css={css`
        // display: block;
        // a {
        //   cursor: pointer;
        //   text-decoration: none;
        //   color: var(--color-text);
        //   font-weight: bold;
        //   &:hover {
        //     color: var(--color-interactive-light);
        //   }
        // }
        // button {
        //   color: var(--color-text-negative) !important;
        //   // font-weight: bold !important;
        //   background-color: var(--color-interactive-light) !important;
        //   border: 0px !important;
        // }
        // textarea {
        //   background: var(--color-lighter-primary) !important;
        //   border: 0px !important;
        //   color: var(--color-text) !important;

        // }
      `}
      gitalkConfig
    >
      <Gitalk options={gitalkConfig} />
    </div>
  )
}
